module.exports = __webpack_public_path__ + "img/velocover.4b072d69.jpg";